.toolbarContainer {
	container-type: inline-size;
}

.toolbar {
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
	grid-template-areas: "bulk center right";
	align-items: center;
	gap: 0.5rem;
}

.bulkActions,
.centerActions,
.rightActions {
	display: flex;
	min-width: 0;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.5rem;
}

.bulkActions {
	grid-area: bulk;
	justify-self: start;
}

.centerActions {
	grid-area: center;
	justify-self: center;
}

.rightActions {
	grid-area: right;
	justify-content: flex-end;
	justify-self: end;
}

@container (max-width: 58rem) {
	.toolbar {
		grid-template-columns: minmax(0, 1fr) auto;
		grid-template-areas:
			"center center"
			"bulk right";
	}

	.centerActions {
		justify-self: center;
	}

	.rightActions {
		justify-self: end;
	}
}
